import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from "@shopify/polaris";
import { Provider as StoreProvider } from "react-redux";
import enTranslations from '@shopify/polaris/locales/en.json';
import { createStore, applyMiddleware, compose } from "redux";

import './index.css';
import App from './App';
import reducer from './store/reducers';
import { isAppBridgeContext, loadAppBridge } from './services/app.service';

const composeEnhancers = (process.env.NODE_ENV === 'development' ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose);
const store = createStore(reducer, composeEnhancers(applyMiddleware()));

const root = createRoot(document.getElementById('root'));

function renderApp() {
  root.render(
    <React.StrictMode>
      <StoreProvider store={store}>
        <AppProvider i18n={enTranslations}>
          <App />
        </AppProvider>
      </StoreProvider>
    </React.StrictMode>
  );
}

const query = Object.fromEntries(new URLSearchParams(window.location.search).entries());

if (isAppBridgeContext(query) && process.env.REACT_APP_API_KEY) {
  loadAppBridge(process.env.REACT_APP_API_KEY)
    .then(renderApp)
    .catch((error) => {
      console.error('[App Bridge] failed to load', error);
    });
} else {
  renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
